import { InputLabel, Select } from "@mui/material";
import { styled } from "styled-components";

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 12px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgb(121, 121, 121);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  color: #a2a2a2;

  & .Mui-focused {
    color: blue;
  }
`;
